export default __webpack_public_path__ + "static/media/footer-maps.55f9a42e.png";